import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useForumData } from '../lib/forum';

const ForumContext = createContext(null);
export const ForumProvider = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const state = useForumData(user && location.pathname.startsWith('/foro') ? `/categories?route=${encodeURIComponent(location.pathname)}` : null);
  const categories = state.data || [];
  return <ForumContext.Provider value={{ ...state, categories, findCategory: (id) => categories.find((c) => c.id === id), findBrand: (cid, bid) => categories.find((c) => c.id === cid)?.brands.find((b) => b.id === bid) }}>{children}</ForumContext.Provider>;
};
export const useForumCatalog = () => useContext(ForumContext);
